<template>
  <div v-click-outside="focusOut" class="position-relative">
    <FloatLabel
      :class="`${selectDisabled ? 'float-label' : ''}`"
      :label="label"
      :optional="optional"
    >
      <div
        :id="id"
        class="shadow-none form-control select-custom"
        @click="handleFocus"
        ref="customSelect"
        :class="[
          `${error ? 'invalid' : ''} ${
            selectDisabled ? 'disabled' : ''
          } ${this.selectValue !== '' ? '' : 'gray'} ${
            isClear && !isVariant ? 'option-custom' : ''
          }`,
        ]"
      >
        <p class="mb-0 lh-2 text-nowrap overflow-hidden">
          {{
            this.val !== ""
              ? isVariant
                 ? this.val.includes("Not sure")
                  ? "Not sure"
                  : this.val.includes("Other")
                  ? "Other" 
                  : this.val.includes("N/A")
                    ? "N/A"
                    : this.val.replace(/\|/g, ' ')
                : this.val
              : this.options.length === 0
                ? "N/A"
                : "Select one"
          }}
        </p>
      </div>
      <b-icon
        v-if="isClear"
        icon="x"
        class="clear-select-icon"
        @click="handleResetOptions"
      ></b-icon>
    </FloatLabel>
    <div
      class="result-panel"
      v-if="this.togglePanel"
      ref="scrollContainer"
      @scroll="handleScroll"
    >
      <ul>
        <li :class="`${this.val === '' ? 'active' : 'disable-text'}`" ref="option">
          Select one
        </li>
        <li
          :class="{ selected: selectValue === option }"
          v-for="(option, index) in paginated"
          :key="index"
          :value="
            isVariant ? option.value : isColour ? option.toUpperCase() : option
          "
          @click="handleChange(option)"
          ref="option"
        >
          {{ isVariant ? mappedDisplay(option.key) : mappedDisplay(option) }}
        </li>
      </ul>
    </div>
    <div class="fs-12 text-right mb-2 mt-n3 pr-2 err-text">
      {{ error ? helperText : "" }}
    </div>
    <img
      v-if="shouldShowSpinner"
      :class="['input-spinner', { 'has-clear-icon': isClear }]"
      src="../../assets/images/input-spinner.gif"
    />
  </div>
</template>
<script>
import {
  CLEAR_INFO_MODEL,
  CLEAR_INFO_YEAR,
  CLEAR_INFO_EXTEND,
  CLEAR_INFO_BODY_TYPES,
  CLEAR_INFO_FUEL_TYPES,
  CLEAR_INFO_DRIVE_TYPES,
  CLEAR_INFO_TRANS,
  CLEAR_INFO_SERIES,
  CLEAR_INFO_ENGINE_TYPES,
  CLEAR_INFO_ENGINE_SIZES,
  CLEAR_INFO_NUMBER_OF_SEATS,
} from "@/store/authenticate-seller/actions";
import {
  FETCH_ALL
} from "@/store/info/actions";
import { mapState } from "vuex";
import { blankOptionList } from "@/helper/constant";
import { SET_LOADING_AG } from "@/store/info/actions";
export default {
  components: {
    FloatLabel: () => import("./FloatLabel.vue"),
  },
  name: "CustomClearSelect",
  inheritAttrs: false,
  model: {
    prop: "selectValue",
    event: "change",
  },
  data() {
    return {
      isLoading: false,
      isDOMUpdateComplete: false,
      togglePanel: false,
      limit: 20,
      page: 1,
    };
  },
  props: {
    selectValue: {
      type: [Number, String],
      default: () => "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: String,
    name: {
      type: String,
      default: () => "",
    },
    mapper: {
      type: Object,
      default: () => null,
      require: false,
    },
    isLoadAble: {
      type: Boolean,
      default: () => false,
    },
    id: {
      type: String,
      default: () => "",
      require: true,
    },
    error: Boolean,
    helperText: String,
    isFocus: Boolean,
    optional: Boolean,
    selectDisabled: Boolean,
    isClear: Boolean,
  },
  computed: {
    val: {
      get: function () {
        return this.selectValue;
      },
      set: function () {},
    },
    ...mapState({
      authenticateData: (state) => state.authenticateSeller,
      info: (state) => state.authenticateSeller.carInfo,
      isLoadingAG: (state) => state.info.isLoadingAG,
      currentAPIParams: (state) => state.info.currentAPIParams,
      isAGSource: (state) => state.common.isAGSource,
    }),
    totalPage() {
      return Math.ceil(this.options.length / this.limit);
    },
    paginated() {
      return this.page <= this.totalPage
        ? [...this.options].slice(0, this.limit * this.page)
        : [...this.options];
    },
    isVariant() {
      return (
        this.label === "Variant" ||
        this.label === "Sub model"
      );
    },
    isColour() {
      return this.label === "Colour";
    },
    shouldShowSpinner() {
      const originalCondition = this.isLoading && this.isLoadAble;
      
      // Exclude serviceHistory field from showing spinner
      const fieldName = this.name;
      if (fieldName === 'serviceHistory') {
        return originalCondition;
      }
      
      // Only show spinner for fields not in current API params
      let isFieldNotInParams;
      if (fieldName === 'badgeEdition') {
        const hasBadge = this.currentAPIParams && Object.prototype.hasOwnProperty.call(this.currentAPIParams, 'badge');
        isFieldNotInParams = !hasBadge;
      } else {
        isFieldNotInParams = !this.currentAPIParams || !Object.prototype.hasOwnProperty.call(this.currentAPIParams, fieldName);
      }
      
      const agCondition = this.isAGSource && this.isLoadingAG && isFieldNotInParams;
      
      return originalCondition || agCondition;
    },
  },
  methods: {
    handleChange: function (option) {
      this.$emit("change", this.isVariant ? option.value : option);
      this.$emit("setNextInput");
      this.togglePanel = false;
    },
    handleResetOptions: function () {
      if (this.label === "Model") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_MODEL);
      } else if (this.label === "Year") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_YEAR);
      } else if (this.label === "Variant" || this.label === "Sub model") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_EXTEND);
      } else if (this.label === "Body type") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_BODY_TYPES);
      } else if (this.label === "Fuel type") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_FUEL_TYPES);
      } else if (this.label === "Drive type") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_DRIVE_TYPES);
      } else if (this.label === "Transmission") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          drive: this.info.drive,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_TRANS);
      } else if (this.label === "Series") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          drive: this.info.drive,
          transmission: this.info.transmission,
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_SERIES);
      } else if (this.label === "Engine type") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          drive: this.info.drive,
          transmission: this.info.transmission,
          series: !blankOptionList.includes(this.info.series) ? this.info.series : '',
          locid: parseInt(this.authenticateData.locid),
        });
        this.$store.dispatch(CLEAR_INFO_ENGINE_TYPES);
      } else if (this.label === "Engine size") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          drive: this.info.drive,
          transmission: this.info.transmission,
          series: !blankOptionList.includes(this.info.series) ? this.info.series : '',
          locid: parseInt(this.authenticateData.locid),
          engineType: this.info.engineType,
        });
        this.$store.dispatch(CLEAR_INFO_ENGINE_SIZES);
      } else if (this.label === "Number of seats") {
        this.setLoadingAG(true);
        this.$store.dispatch(FETCH_ALL, {
          make: this.info.make,
          model: this.info.model !== 'Other' ? this.info.model : '',
          year: this.info.year,
          badge: !blankOptionList.includes(this.info.badge) ? this.info.badge : '',
          edition: !blankOptionList.includes(this.info.edition) ? this.info.edition : '',
          bodyType: this.info.bodyType,
          fuelType: this.info.fuelType,
          drive: this.info.drive,
          transmission: this.info.transmission,
          series: !blankOptionList.includes(this.info.series) ? this.info.series : '',
          locid: parseInt(this.authenticateData.locid),
          engineType: this.info.engineType,
          engineSize: this.info.engineSize,
        });
        this.$store.dispatch(CLEAR_INFO_NUMBER_OF_SEATS);
      }
    },
    setLoadingAG(isLoading) {
      if (this.isAGSource) {
        this.$store.dispatch(SET_LOADING_AG, isLoading);
      }
    },
    mappedDisplay: function (e) {
      if (this.mapper !== null) {
        return this.mapper[this.label][e] || e;
      }
      return e;
    },
    handleFocus: function () {
      if (!this.selectDisabled) {
        if (!this.isDOMUpdateComplete) {
          this.isLoading = true;
        } else {
          this.handleTogglePanel();
        }
      }
    },
    handleTogglePanel() {
      this.togglePanel = !this.togglePanel;
    },
    handleScroll: function () {
      const scrollScreen = this.$refs.scrollContainer;
      const bottomOfScreen =
        scrollScreen.scrollTop >= scrollScreen.offsetHeight * this.page;
      if (bottomOfScreen && this.page < this.totalPage) {
        this.page++;
      }
    },
    focusOut() {
      this.togglePanel = false;
    },
  },
  async updated() {
    await this.$nextTick();
    if (this.options.length >= 1 || this.val !== "") {
      this.isDOMUpdateComplete = true;
      if (this.isLoading) {
        this.isLoading = false;
        this.togglePanel = true;
      }
    }
  },
};
</script>
<style lang="scss">
select.form-control.invalid,
input.form-control.invalid {
  border-color: red !important ;
}
.form-control.disabled {
  border: none;
  background-color: #e9ecef;
  opacity: 1;
}
.float-label > span {
  z-index: 0;
  background-color: transparent;
  &::after {
    background: none;
  }
}
.err-text {
  color: red;
  font-style: italic;
  min-height: 16px;
}
.border-lable-flt {
  margin-bottom: 0;
}
.non-foucus {
  border-color: #ced4da !important;
}
.next-select-input {
  color: #383c3f;
  background-color: #fff;
  border-color: #00bb65 !important;
  outline: 0;
}
.select-custom {
  position: relative;

  &.gray {
    color: #989898 !important;
  }

  option {
    color: #383c3f !important;

    &:first-child {
      color: #989898 !important;
    }
  }
}
.clear-select-icon {
  position: absolute;

  right: 33px;
  bottom: 27%;
  font-size: 25px;
  cursor: pointer;
}

.option-custom {
  padding-right: 38%;
}

.input-spinner {
  position: absolute;
  top: 50%;
  right: 35px;
  transform: translateY(-85%);
  width: 24px;

  &.has-clear-icon {
    right: 55px;
  }
}

.disable-text {
  pointer-events: none;
  color: #929090;
  user-select: none;
}

@media screen and(min-width: 768px) {
  .input-spinner {
    right: 45px !important;

    &.has-clear-icon {
      right: 55px !important;
    }
  }
}
</style>
